import api from "./api";
import AuthService from "./auth-service";

const MICRO_SERVICE_URL_ASSEMBLY = "/assembleia";

class AssemblyService {
  async getAll(queryparams) {
    const queryparamsObj = new URLSearchParams();
    const user = JSON.parse(localStorage.getItem('user'));

    if (user && user.email) queryparamsObj.append('email', user.email);
    for (const key in queryparams) queryparamsObj.append(key, queryparams[key]);

    const response = await api.get(
      `${MICRO_SERVICE_URL_ASSEMBLY}/api/shareholder/assemblies?${queryparamsObj.toString()}`,
    );
    return response.data;
  }

  async validateVotingToken(votingToken, cpfCnpj) {
    const headers = { dontUseBearerToken: true };
    const tokenParts = votingToken.split(".");
    const payload = JSON.parse(atob(tokenParts[1]));

    if (!payload || !payload.sub) throw new Error('Invalid token');

    const [,,, email] = payload.sub.split(":");
    if (email) AuthService.setUserEmail(email);
    
    const response = await api.post(
      `${MICRO_SERVICE_URL_ASSEMBLY}/api/vote/validate-voting-token`,
      { votingToken, cpfCnpj },
      { headers }
    );

    return response.data;
  }

  async getAssemblyByVotingToken(votingToken) {
    const tokenParts = votingToken.split(".");
    const payload = JSON.parse(atob(tokenParts[1]));
    const idAssembly = payload.sub.split(":")[0];
    const response = await api.get(
      `${MICRO_SERVICE_URL_ASSEMBLY}/api/shareholder/assemblies/${idAssembly}`
    );
    return response.data;
  }

  async registerVote(assemblyId, votes) {
    const headers = { sendExternalIpAddress: true };
    const response = await api.post(
      `${MICRO_SERVICE_URL_ASSEMBLY}/api/vote/submit`,
      { assemblyId, votes },
      { headers }
    );
    return response.data;
  }

  async getAssemblyById(idAssembly) {
    const response = await api.get(
      `${MICRO_SERVICE_URL_ASSEMBLY}/api/shareholder/assemblies/${idAssembly}`
    );
    return response.data;
  }

  async getStatusAssemblyByVotingToken(token) {
    const headers = { dontUseBearerToken: true };

    const response = await api.get(
      `${MICRO_SERVICE_URL_ASSEMBLY}/api/assemblies/by-token/${token}`,
      { headers }
    );
    
    return response.data;
  }

  async getAnnoucementByIdAssembly(assemblyId) {
    const response = await api.get(
      `${MICRO_SERVICE_URL_ASSEMBLY}/api/communicate?assemblyId=${assemblyId}`
    );
    return response.data;
  }

  async getVotingStatusReport(assemblyId, nameReport) {
    const response = await api.get(
      `${MICRO_SERVICE_URL_ASSEMBLY}/api/shareholder/${assemblyId}/voting-status-report`
    );

    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
    var fileLink = document.createElement('a');
    let nameFile = nameReport.replace(/\s+/g, '-').toLowerCase();

    fileLink.href = fileURL;
    fileLink.setAttribute('download', `${nameFile}.csv`);
    document.body.appendChild(fileLink);
    fileLink.click();
  }
}

export default new AssemblyService();
